<template>
  <v-dialog v-model="getModalPermissaoFuncionario" persistent max-width="720px" transition="dialog-transition">
    <v-card>
      <v-card-title>Solicitar Permissão</v-card-title>
      <v-form class="px-5" ref="form">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-autocomplete :items="getFuncionarios" v-model="funcionario.login" item-text="nome" item-value="login" outlined dense label="Funcionário" @click="$event.target.select()" :rules="rules.login"></v-autocomplete>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field dense outlined label="Senha" v-model="funcionario.password" type="password" autocomplete="new-password" placeholder="******" @click="$event.target.select()" @keup.enter="solicitarPermissao" :rules="rules.password" @keyup.enter="solicitarPermissao" />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn color="default" @click="setModalPermissaoFuncionario(false)" outlined dense :loading="$store.getters.getOverlay">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="solicitarPermissao" outlined dense :loading="$store.getters.getOverlay">Solicitar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      funcionario: {
        login: "",
        password: "",
      },
      rules: {
        login: [(v) => !!v || "Campo obrigatório."],
        password: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters(["getFuncionarios", "getModalPermissaoFuncionario", "getPermissaoFuncionario"]),
  },
  methods: {
    ...mapActions(["listarFuncionarios", "setModalPermissaoFuncionario", "solicitarPermissaoFuncionario"]),
    solicitarPermissao() {
      if (this.$refs.form.validate()) {
        this.solicitarPermissaoFuncionario({
          ...this.funcionario,
          permissao: this.getPermissaoFuncionario.permissao,
          metodo: this.getPermissaoFuncionario.metodo,
        })
        .then((res) => {
          console.log(res)
          this.funcionario.password = "";
        })
        .catch((e) => {
          this.funcionario.login = "";
        });
      }
    },
  },
  created() {
    this.listarFuncionarios();
  },
};
</script>
